const { trackGtm, trackGtm4 } = require('../../../../js/functions');

module.exports = {
	init() {
		const links = this.root.querySelectorAll('.arrowed-link');
		const widgetName = this.root.getAttribute('data-parent');
		const widgetTitle = this.root.getAttribute('data-parent-title');
		const secondaryWidgetTitle = this.root.getAttribute('data-secondary-title');
		const parentTitle = this.root
			.closest('.carousel-highlight')
			?.querySelector('.carousel-highlight--title').innerText;

		const backupTitle = secondaryWidgetTitle
			? secondaryWidgetTitle
			: parentTitle
			? parentTitle
			: 'No title: Title not set';

		links.forEach(element => {
			element.addEventListener('click', () => {
				trackGtm({
					eventCategory: 'cta',
					eventAction: element.previousElementSibling.innerText,
					eventLabel: element.href,
				});
				trackGtm4({
					event: 'GA4_event_c_cta',
					widget_name: widgetName,
					widget_title: widgetTitle ? widgetTitle : backupTitle,
					link_text: element.innerHTML,
					link_url: element.href,
					button_type: '',
				});
			});
		});
	},
};
